import { useState, useEffect } from "react";
import { Queue } from "@/types/queue";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";

export const useQueues = () => {
  const [queues, setQueues] = useState<Queue[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();
  const navigate = useNavigate();

  const fetchQueues = async () => {
    try {
      setIsLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate("/login", { replace: true });
        return;
      }

      const { data, error } = await supabase
        .from('queues')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });

      if (error) throw error;

      console.log('Fetched queues:', data);
      setQueues(data);
    } catch (error: any) {
      console.error('Error fetching queues:', error);
      toast({
        title: "Error fetching queues",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchQueues();

    const channel = supabase
      .channel('queue-list-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'queues'
        },
        (payload) => {
          console.log('Queue update:', payload);
          fetchQueues();
        }
      )
      .subscribe((status) => {
        console.log('Queue list subscription status:', status);
      });

    return () => {
      console.log('Cleaning up queue list subscription');
      supabase.removeChannel(channel);
    };
  }, []);

  return { queues, fetchQueues, isLoading };
};